module.exports = __webpack_public_path__ + "090020dea3953d215e29cfb356eb599a.jpg";